module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidenav"
  }, [_c('router-link', {
    staticClass: "success",
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("LOGIN")]), _vm._v(" "), _c('router-link', {
    staticClass: "info",
    attrs: {
      "to": {
        name: 'my_rents'
      }
    }
  }, [_vm._v("MINHAS LOCAÇÕES")]), _vm._v(" "), (_vm.user) ? [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center logged-user"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" SAIR")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a396d49!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/partials/PartialDrawerNavigation.vue
// module id = 296
// module chunks = 18